// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_m8T","label":"styles_label__23Noh"};